import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import EditForm from "./EditForm";

const EditSupplier = () => {
  return (
    <>
      <div className="d-flex flex-column" style={{ flexGrow: '1', overflow: "hidden" }}>
      <Helmet>
				<title>Supplier - Edit</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <EditForm />
      </div>
      </div>
    </>
  );
};

export default EditSupplier;
